import { Text } from "../../Text/Text/Text";
import styles from "./AttributeItem.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var AttributeItem = function AttributeItem(_ref) {
  var label = _ref.label,
    value = _ref.value;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.attributeItem,
    "data-e2e-name": "attribute_item_element",
    children: [/*#__PURE__*/_jsx(Text, {
      typog: "bodycopySmall",
      className: styles.label,
      childrenInline: true,
      "data-e2e-name": "attribute_item_label",
      children: label
    }), /*#__PURE__*/_jsx(Text, {
      typog: "bodycopySmall",
      className: styles.value,
      "data-e2e-name": "attribute_item_value",
      children: value
    })]
  });
};